export const currentUser = (state) => state.currentUser || {}
export const getUsers = (state) => state.users
export const getCompanyInfo = (state) => state.companyInfo
export const getFamilyStatus = (state) => state.familyStatus
export const getPostCategories = (state) => state.postCategories

